import { useInvalidateQueries } from '@/hooks/useInvalidateQueries'
import { QUERY_KEYS } from '@/lib/queryKeys'

export function useInvalidateReferralsQueries() {
  const invalidateQueries = useInvalidateQueries()

  return async function () {
    return invalidateQueries([
      QUERY_KEYS.referrals(),
      QUERY_KEYS.referralStats(),
    ])
  }
}
